import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9","key":"svg-1"}],["path",{"d":"M11.5 7.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-2"}],["path",{"d":"M11.5 16.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-3"}]]

const IconYinYang = createReactComponent('outline', 'yin-yang', 'YinYang', __iconNode);

export default IconYinYang;